export default "__VITE_ASSET__B7Q86zAL__"